export default {
  methods: {
    MessageAlert({
      type = 'info',
      message = '',
      duration = 5000,
      offset = 20,
      customClass = '',
      showClose = false
    } = {}) {
      ElMessage({
        message,
        type,
        duration,
        offset,
        customClass,
        showClose
      });
    }
  }
};